import React from 'react';
import PropTypes from 'prop-types';
import { getFaro } from 'flow/api-clients/faro-client';

import ErrorBoundaryView from 'flow/components/error-boundary/ErrorBoundaryView';
import { addGeneralLogEntry } from 'flow/utils/browser-utils';

class LeftPaneErrorBoundary extends React.Component {
    static propTypes = {
        children: PropTypes.node.isRequired,
        tab: PropTypes.string,
    };
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.state.hasError &&
            prevState.hasError &&
            this.props.tab !== prevProps.tab
        ) {
            this.setState({ hasError: false });
        }
    }

    componentDidCatch(error, _info) {
        getFaro()?.api.pushError(error, {
            context: { component: 'LeftPane', severity: 'critical' },
        });
        addGeneralLogEntry(`Error reported: ${error}`);
    }

    onRetry = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return <ErrorBoundaryView onClick={this.onRetry} />;
        }

        return this.props.children;
    }
}

export default LeftPaneErrorBoundary;
